// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7172428c","455":"bd99fe3f","977":"7c53ce91"}[chunkId] + ".chunk.js";
};